import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";
import moment from "moment";
import "moment/locale/es"; // Importa el idioma español
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR ARCHIVOS
import { getData } from "../../../services/library";
import CandidatosDniExistente from "./CandidatosDniExistente";
//campos legajo fechaingreso observaciones agregado por guille a abrzo
const CandidatosForm = ({
  isEditMode,
  rowInfo,
  handleOpenCloseModalForm,
  obtenerCandidatos,
  mostrarAlertaTemporal,
  idSolicitudQueAplica,
}) => {
  const [data, setData] = useState({
    id: isEditMode ? rowInfo.id : undefined,
    nombre: isEditMode ? rowInfo.nombre : "",
    apellido: isEditMode ? rowInfo.apellido : "",
    dni: isEditMode ? rowInfo.dni : "",
    tel_contacto: isEditMode ? rowInfo.telefono : "",
    mail_contacto: isEditMode ? rowInfo.mail : "",
    id_solicitud_a_aplicar: idSolicitudQueAplica,
    uuid_archivo: isEditMode ? rowInfo.uuid_archivo : uuidv4(),
    estado: isEditMode ? rowInfo.estado : 1,
    user: localStorage.getItem("user"), 
    legajo: isEditMode ? rowInfo.legajo : null,
    fechaingreso: isEditMode ? rowInfo.fechaingreso : null,
    observaciones: isEditMode ? rowInfo.observaciones : null,
  });  
//console.log("en candidatos form data",data)
//console.log("rowInfo",rowInfo)
  const [valorDeVueltaDni, setValorDeVueltaDni] = useState(null);
  const [dnis, setDnis] = useState([]);

  const [openDniExistenteModal, setOpenDniExistenteModal] = useState(false);
  const [idSolicitud, setIdSolicitud] = useState(-1);

  const getDni = () => {
    getData("/SP_candidatos/getdni", setDnis);
  };

  useEffect(() => {
    getDni();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleKeyPress = (event) => {
    const allowedChars = /[0-9\s-]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  };

  const isValidEmail = (email) =>
    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

  const onConfirmDni = () => {
    setOpenDniExistenteModal(false); // Cierra el modal
    procesarSolicitud(); // Continúa con la solicitud
  };

  // Función que se llama si el usuario cancela en el modal
  const onCancelDni = () => {
    setOpenDniExistenteModal(false); // Cierra el modal
    mostrarAlertaTemporal(
      "Se canceló la solicitud por decisión del usuario",
      "info"
    ); // Alerta de cancelación
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    logEventos(
      isEditMode ? "Editar candidato" : "Agregar candidato",
      "Candidatos",
      isEditMode ? "Editar un candidato" : "Crear un candidato",
      localStorage.getItem("user")
    );

    if (
      data.nombre.trim() === "" ||
      data.apellido.trim() === "" ||
      data.dni.trim() === "" ||
      data.dni.length < 8 ||
      data.tel_contacto.trim() === "" ||
      data.tel_contacto.length < 7 ||
      data.mail_contacto.trim() === "" ||
      !isValidEmail(data.mail_contacto)
    ) {
      mostrarAlertaTemporal(
        "Por favor, complete todos los campos obligatorios y verifique que los datos sean correctos.",
        "error"
      );
      return;
    }

    const dniInDB = dnis.filter(
      (dni) => dni.dni === data.dni && dni.id !== (isEditMode ? data.id : null)
    );

    const stringAllIdsDnis = (dnis) => {
      let ids = [];

      for (let i = 0; i < dnis.length; i++) {
        if (!ids.includes(dnis[i].id_solicitud_a_aplicar)) {
          ids.push(dnis[i].id_solicitud_a_aplicar);
        }
      }

      return ids;
    };
    if (dniInDB.length > 0) {
      const dnisInSolicitud = stringAllIdsDnis(dniInDB);
      setIdSolicitud(dnisInSolicitud.join(","));
      setOpenDniExistenteModal(true);
      return;
    }

    procesarSolicitud();
  };

   //  handleputsolicitud();

// async function handleputsolicitud(e) {
//  console.log("put del campo activo a 3");
//       e.preventDefault();
   
// //       await fetch(
// //           UrlApi + "/solicitudDePersonal/" +{id}
// //           {
// //             method: "PUT",
// //             headers: { "Content-Type": "application/json" },
// //             body: JSON.stringify({
// //            activa:3
           
// //             }),
// //           }
// //         );

//  try {
//     const response = await fetch(`${UrlApi}/solicitudDePersonal/${idSolicitudQueAplica}`, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         activa: 3
//       }),
//     });

//     if (!response.ok) {
//       throw new Error("Error al actualizar la solicitud");
//     }

//     const result = await response.json();
//     console.log("Solicitud actualizada:", result);
//   } catch (error) {
//     console.error("Error en PUT:", error.message);
//   }
//   }

async function handleputsolicitud(idSolicitudQueAplica,rowInfo) {
  if (rowInfo.estado === 2) {
    console.log("La solicitud ya fue aprobada (activa = 2), no se actualiza.");
    return;
  }

  console.log("Ejecutando PUT: activa = 3");

  try {
    const response = await fetch(`${UrlApi}/solicitudDePersonal/${idSolicitudQueAplica}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        activa: 3
      }),
    });

    if (!response.ok) {
      throw new Error("Error al actualizar la solicitud");
    }

    const result = await response.json();
    console.log("Solicitud actualizada:", result);
  } catch (error) {
    console.error("Error en PUT:", error.message);
  }
}

//original
//   const procesarSolicitud = async () => {
//     let solicitud = isEditMode
//       ? { ...data, uuid_archivo: undefined, is_solicitud_a_aplicar: undefined }
//       : { ...data, id: undefined };

//     const url = isEditMode
//       ? `${UrlApi}/SP_candidatos/${rowInfo.id}`
//       : `${UrlApi}/SP_candidatos`;
//     const method = isEditMode ? "PUT" : "POST";
// // usar rowInfo.id como parametro para encontrar la solicitud a la que pertecene y 
// // pasar el estado a 3 que seria para filtrar los preleccioans
//     try {
//       const response = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(solicitud),
//       });

//       if (response.ok) {
//         mostrarAlertaTemporal(
//           isEditMode
//             ? "Candidato actualizado correctamente"
//             : "Candidato creado con éxito",
//           "success"
//         );
       
      
//         obtenerCandidatos();
//         handleOpenCloseModalForm();
//       } else {
//         const error = await response.json();
//         mostrarAlertaTemporal(`Error: ${error.message}`, "error");
//       }
//     } catch (error) {
//       console.error("Error en la solicitud:", error);
//       mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
//     }
//   };

  const procesarSolicitud = async (e) => {
    let solicitud = isEditMode
      ? { ...data, uuid_archivo: undefined, is_solicitud_a_aplicar: undefined }
      : { ...data, id: undefined };

    const url = isEditMode
      ? `${UrlApi}/SP_candidatos/${rowInfo.id}`
      : `${UrlApi}/SP_candidatos`;
    const method = isEditMode ? "PUT" : "POST";
// usar rowInfo.id como parametro para encontrar la solicitud a la que pertecene y 
// pasar el estado a 3 que seria para filtrar los preleccioans
    try {
      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(solicitud),
      });

      if (response.ok) {
        mostrarAlertaTemporal(
          isEditMode
            ? "Candidato actualizado correctamente"
            : "Candidato creado con éxito",
          "success"
        );
       
          // ✅ Verificar si cambió alguno de los campos sensibles
      if (
        isEditMode &&
        (
          data.legajo !== rowInfo.legajo 
        
        )
      ) {
        // Llamar al PUT en solicitudDePersonal (cambiar activa a 3)
        await handleputsolicitud(idSolicitudQueAplica,rowInfo)
      }
      
        obtenerCandidatos();
        handleOpenCloseModalForm();
      } else {
        const error = await response.json();
        mostrarAlertaTemporal(`Error: ${error.message}`, "error");
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
    }
  };

  const RRHH = localStorage.getItem("adminrrhh");
  return (
    <>
      {openDniExistenteModal && (
        <CandidatosDniExistente
          open={openDniExistenteModal}
          onConfirm={onConfirmDni}
          onCancel={onCancelDni}
          idSolicitud={idSolicitud}
        />
      )}
      <Dialog
        open={true}
        onClose={handleOpenCloseModalForm}
        maxWidth="lg"
        fullWidth
      >
        <Box sx={{ backgroundColor: "#1F618D", marginBottom: 4 }}>
          <DialogTitle>
            <Typography variant="h6" align="center" color="#fff">
              {isEditMode ? "Editar candidato" : "Nuevo candidato"}
            </Typography>
          </DialogTitle>
        </Box>
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre"
                name="nombre"
                value={data.nombre}
                onChange={handleChange}
                required
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Apellido"
                name="apellido"
                value={data.apellido}
                onChange={handleChange}
                required
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="DNI"
                name="dni"
                value={data.dni.trim()}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                required
                inputProps={{ maxLength: 8 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Teléfono de contacto"
                name="tel_contacto"
                value={data.tel_contacto}
                onKeyPress={handleKeyPress}
                onChange={handleChange}
                required
                inputProps={{ maxLength: 18 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Correo de contacto"
                name="mail_contacto"
                value={data.mail_contacto}
                onChange={handleChange}
                required
                inputProps={{ maxLength: 100 }}
                helperText={
                  data.mail_contacto && !isValidEmail(data.mail_contacto)
                    ? "Correo electrónico no válido"
                    : ""
                }
                error={data.mail_contacto && !isValidEmail(data.mail_contacto)}
              />
            </Grid>
{/* ]]revisar {(RRHH === "1" && isEditMode && rowInfo.estado === 3) ? ( */}
{(RRHH === "1" && isEditMode) ? (
  <>
    <Grid item xs={12}>
      <TextField
        fullWidth
        label="Legajo"
        name="legajo"
        value={data.legajo}
        onChange={handleChange}
        inputProps={{ maxLength: 50 }}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        fullWidth
        label="Fecha de ingreso"
        name="fechaingreso"
        size="small"
        type="date"
        value={moment(data.fechaingreso).format("YYYY-MM-DD")}
        onChange={handleChange}
        inputProps={{ maxLength: 50 }}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        fullWidth
        label="Observaciones"
        name="observaciones"
        value={data.observaciones}
        onChange={handleChange}
        inputProps={{ maxLength: 50 }}
      />
    </Grid>
  </>
):null}




            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <Button onClick={handleOpenCloseModalForm} color="error">
                Cancelar
              </Button>
              <Button onClick={handleSubmit} color="primary">
                {isEditMode ? "Guardar" : "Agregar"}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Dialog>
    </>
  );
};

export default CandidatosForm;
